// import React, { useEffect, useState } from "react";
// import { Modal, Button, Form } from "react-bootstrap";
// import { State } from "country-state-city";

// export default function FilterModal({
//   show,
//   onHide,
//   applyFilters,
//   removeFilters,
//   apidata,
// }) {
//   const [filteredCities, setFilteredCities] = useState([]);

//   const getStateName = (stateCode) => {
//     const state = State.getStateByCodeAndCountry(stateCode, "IN");
//     return state ? state.name : stateCode;
//   };

//   useEffect(() => {}, [apidata]);

//   return (
//     <Modal show={show} onHide={onHide}>
//       <Modal.Header closeButton>
//         <Modal.Title>Filter Options</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <Form></Form>
//       </Modal.Body>
//       <Modal.Footer>
//         <Button variant="secondary" onClick={removeFilters}>
//           Remove Filters
//         </Button>
//         <Button variant="primary" onClick={applyFilters}>
//           Apply Filters
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// }

import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function FilterModal({
  show,
  onHide,
  applyFilters,
  removeFilters,
  apidata,
}) {
  const [status, setStatus] = useState("");
  const [city, setCity] = useState("");
  const [date, setDate] = useState("");
  const [cityOptions, setCityOptions] = useState([]);

  // Extract unique cities from apidata
  useEffect(() => {
    if (apidata && apidata.length > 0) {
      const uniqueCities = [...new Set(apidata.map((job) => job.city))];
      setCityOptions(uniqueCities);
    }
  }, [apidata]);

  const handleApply = () => {
    applyFilters({ status, city, date });
    onHide();
  };

  const handleRemove = () => {
    setStatus("");
    setCity("");
    setDate("");
    removeFilters();
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {/* Status Filter */}
          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="">All</option>
              <option value="Open">Open</option>
              <option value="Close">Close</option>
            </Form.Select>
          </Form.Group>

          {/* City Filter */}
          <Form.Group className="mb-3">
            <Form.Label>City</Form.Label>
            <Form.Select value={city} onChange={(e) => setCity(e.target.value)}>
              <option value="">All</option>
              {cityOptions.map((cityName, index) => (
                <option key={index} value={cityName}>
                  {cityName}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {/* Date Filter */}
          <Form.Group className="mb-3">
            <Form.Label>Date</Form.Label>
            <Form.Control
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleRemove}>
          Remove Filters
        </Button>
        <Button variant="primary" onClick={handleApply}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
